import React, { useReducer, useEffect } from "react";
import {
    MapContainer,
} from "react-leaflet";
import { reducer, initialState, Context } from '../../store/reducer';
import NormalHeader from '../../components/Header/normal';
import MapController from '../../components/MapController';
import VectorGrid from "../../components/VectorGrid";
import VectorGrid93 from "../../components/VectorGrid93";
import VectorGrid95_1 from "../../components/VectorGrid95_1";
import VectorGrid98 from "../../components/VectorGrid98";
import Popup95_7 from "../../components/Spot/menu/popup95_7";
import Popup96_1 from "../../components/Spot/menu/popup96_1";
import PopupDefault from "../../components/Spot/menu/popupDefault";
import PopupGeoJson from "../../components/Spot/menu/popupGeoJson";
import { mapConfig } from '../../config/env';
import { tmptestAPI as dataAPI } from "../../utils/api";
import { geoJsonAPI } from "../../utils/api";
import { kashika5Options } from "../../components/Header/normal/kashika5config";
import MapUpdate from "../../components/MapUpdate";
import Geocoder from "../../components/Geocoder";
import Vis93InformationModal from '../../components/Vis93InformationModal';
import Vis95InformationModal from '../../components/Vis95InformationModal';
import Vis96_1InformationModal from '../../components/Vis96_1InformationModal';
import Vis98InformationModal from '../../components/Vis98InformationModal';

// 95_7 マンションの非公開データ
import Data_95_7 from '../../assets/data/95_7_data.json';

// 96_1 建築確認番号（三次市）の非公開データ
import Data_96_1 from '../../assets/data/96_1_data.json';

const renderMarker = (option, d, index, state) => {

    if (option.id === "vis_95_7") {

        // 95_7　マンション評価情報
        return <Popup95_7
          key={index.toString()}
          id={option.id}
          spot={d}
          latitude={d[option.column_lat]}
          longitude={d[option.column_lng]}
          draggable={false}
        />
    } else if (option.id === "vis_96_1" && state["vis_96_1"].isCheckedInModal) {

        // 96_1　建築確認番号（三次市）は同意ウインドウのチェック時にのみ表示される。
        return <Popup96_1
          key={index.toString()}
          id={option.id}
          spot={d}
          option={option}
          latitude={d[option.column_lat]}
          longitude={d[option.column_lng]}
          draggable={false}
        />
    }

}
const renderGeoJson = (option, feature, index, state) => {

  return <PopupGeoJson
    key={index.toString()}
    id={option.id}
    feature={feature}
    option={option}
  />

}

const Layout = () => {
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {

        // APIから法令情報(指定道路図で使用する)を取得する。
        dataAPI.get(process.env.REACT_APP_LAW_JSON)
        .then(res=>{
            dispatch({
                type: 'SET_90_LAW_DATA',
                payload: res.data
            });
        })

        const geoJsonList = [
          {
            url: process.env.REACT_APP_GEO_JSON_XPT001,
            category: "XPT001",
          },
          {
            url: process.env.REACT_APP_GEO_JSON_XKT006,
            category: "XKT006",
          },
          {
            url: process.env.REACT_APP_GEO_JSON_XKT007,
            category: "XKT007",
          },
          {
            url: process.env.REACT_APP_GEO_JSON_XKT010,
            category: "XKT010",
          },
          {
            url: process.env.REACT_APP_GEO_JSON_XKT011,
            category: "XKT011",
          },
          {
            url: process.env.REACT_APP_GEO_JSON_XKT017,
            category: "XKT017",
          },
          {
            url: process.env.REACT_APP_GEO_JSON_XKT018,
            category: "XKT018",
          },
          {
            url: process.env.REACT_APP_GEO_JSON_XKT015,
            category: "XKT015",
          },
        ];

        // geojsonを取得する。
        geoJsonList.map(geoJson => {
          // APIから情報を取得する。
          geoJsonAPI.get(geoJson.url)
            .then(res=>{
              dispatch({
                type: 'SET_DATA',
                category: geoJson.category,
                payload: res.data
              });
            })
        })
        
        // 95_7 マンション評価情報をassetフォルダのjsonから取得する。
        dispatch({
            type: 'SET_DATA',
            category: "vis_95_7",
            payload: Data_95_7
        });   

        // 96_1 建築確認番号（三次市）の非公開データをassetフォルダのjsonから取得する。
        dispatch({
            type: 'SET_DATA',
            category: "vis_96_1",
            payload: Data_96_1
        });
        
        // 事前にデータをロードする処理
        kashika5Options.map(menu =>{
            // APIを使用してマーカー情報を取得する場合は下に追加する。
            
        })

    }, [])
    
    return (
        <Context.Provider value={{ state, dispatch }}>
            <NormalHeader />
            <main className="main">
                <div className="main-inner">

                    {
                      // 各種法令の規制情報_建築基準法（指定道路図）のモーダルはメニューチェック時にのみ表示される。  
                      // 同意は3メニューとも同時に行なっているので、1つのメニューのisCheckedInModalを確認するだけで良い
                        ((state["vis_93_1"].checked || state["vis_93_2"].checked || state["vis_93_3"].checked)
                        && ! state["vis_93_1"].isCheckedInModal)
                      &&
                    	<Vis93InformationModal></Vis93InformationModal>
                    }

                    {
                        // 建築確認番号（三次市）のモーダルはメニューチェック時にのみ表示される。
                      (state["vis_96_1"].checked && ! state["vis_96_1"].isCheckedInModal) && <Vis96_1InformationModal></Vis96_1InformationModal>
                    }

                    {/* 徒歩圏内情報、空き家情報の注釈表示 */}
                    {
                      state["vis_95_1"].showModal && <Vis95InformationModal optionId="vis_95_1"></Vis95InformationModal>
                    }

                    {
                      state["vis_95_2"].showModal && <Vis95InformationModal optionId="vis_95_2"></Vis95InformationModal>
                    }

                    {
                      state["vis_95_3"].showModal && <Vis95InformationModal optionId="vis_95_3"></Vis95InformationModal>
                    }

                    {
                      state["vis_95_4"].showModal && <Vis95InformationModal optionId="vis_95_4"></Vis95InformationModal>
                    }

                    {
                      state["vis_95_7"].showModal && <Vis95InformationModal optionId="vis_95_7"></Vis95InformationModal>
                    }

                    {
                      state["vis_98_1"].showModal && <Vis98InformationModal optionId="vis_98_1"></Vis98InformationModal>
                    }

                    {
                      state["vis_98_2"].showModal && <Vis98InformationModal optionId="vis_98_2"></Vis98InformationModal>
                    }

                    {
                      state["vis_98_3"].showModal && <Vis98InformationModal optionId="vis_98_3"></Vis98InformationModal>
                    }

                    {
                      state["vis_98_14"].showModal && <Vis98InformationModal optionId="vis_98_14"></Vis98InformationModal>
                    }
                    {
                      state["vis_98_19"].showModal && <Vis98InformationModal optionId="vis_98_19"></Vis98InformationModal>
                    }
                    {
                      state["vis_98_22"].showModal && <Vis98InformationModal optionId="vis_98_22"></Vis98InformationModal>
                    }
                    {
                      state["vis_98_29"].showModal && <Vis98InformationModal optionId="vis_98_29"></Vis98InformationModal>
                    }
                    {
                      state["vis_98_30"].showModal && <Vis98InformationModal optionId="vis_98_30"></Vis98InformationModal>
                    }
                    {
                      state["vis_98_32"].showModal && <Vis98InformationModal optionId="vis_98_32"></Vis98InformationModal>
                    }
                    {
                      state["vis_98_35"].showModal && <Vis98InformationModal optionId="vis_98_35"></Vis98InformationModal>
                    }

                    {
                      state["vis_98_36"].showModal && <Vis98InformationModal optionId="vis_98_36"></Vis98InformationModal>
                    }

                    {
                      state["vis_98_37"].showModal && <Vis98InformationModal optionId="vis_98_37"></Vis98InformationModal>
                    }

                    {
                      state["vis_98_39"].showModal && <Vis98InformationModal optionId="vis_98_39"></Vis98InformationModal>
                    }

                    {
                      state["vis_98_52"].showModal && <Vis98InformationModal optionId="vis_98_52"></Vis98InformationModal>
                    }
                    
                    {
                      state["vis_98_54"].showModal && <Vis98InformationModal optionId="vis_98_54"></Vis98InformationModal>
                    }

                    {
                      state["vis_98_55"].showModal && <Vis98InformationModal optionId="vis_98_55"></Vis98InformationModal>
                    }

                    {
                      state["vis_98_56"].showModal && <Vis98InformationModal optionId="vis_98_56"></Vis98InformationModal>
                    }

                    
                    <MapContainer
                        tap={false}
                        id="map"
                        {...mapConfig}
                    >
                        <Geocoder/>
                        <MapUpdate />
                        <MapController />

                        {kashika5Options.map(menu => {
                            return menu.options.map(options => {
                                
                                if ( ! state[options.id].checked) {
                                    return;
                                }

                                if (options.type == "vector") {

                                    // 指定道路図
                                    if(["vis_93_1", "vis_93_2", "vis_93_3"].includes(options.id)) {

                                        // 各種法令の規制情報_建築基準法（指定道路図）は
                                        // メニューでのチェックに加え、モーダルでのチェックも表示の条件
                                        if (state[options.id].isCheckedInModal) {
                                            return <VectorGrid93
                                              id={options.id}
                                              url={options.url}
                                              layerName={options.layerName}
                                              color={options.color}
                                              opacity={options.opacity}
                                              borderColor={options.borderColor}
                                            />
                                        }

                                    } else if(options.id === "vis_95_1") {

                                        // 徒歩圏内の施設充実度
                                        
                                        return <VectorGrid95_1
                                          id={options.id}
                                          url={options.url}
                                          layerName={options.layerName}
                                          color={options.color}
                                          opacity={options.opacity}
                                          borderColor={options.borderColor}
                                        />
                                        
                                  } else if([
                                      "vis_98_1",
                                      "vis_98_2",
                                      "vis_98_36",
                                      "vis_98_37",
                                      "vis_98_38",
                                      "vis_98_39",
                                      "vis_98_40",
                                      "vis_98_41",
                                      "vis_98_42",
                                      "vis_98_43",
                                      "vis_98_44",
                                      "vis_98_45",
                                      "vis_98_46",
                                      "vis_98_47",
                                      "vis_98_48",
                                      "vis_98_49",
                                      "vis_98_50",
                                      "vis_98_51",
                                      "vis_98_52",
                                      "vis_98_53",
                                      "vis_98_54",
                                      "vis_98_55",
                                      "vis_98_56",
                                      "vis_98_57",
                                    ].includes(options.id)) {

                                    // 不動産情報API
                                    return <VectorGrid98
                                      id={options.id}
                                      url={options.url}
                                      layerName={options.layerName}
                                      color={options.color}
                                      opacity={options.opacity}
                                      borderColor={options.borderColor}
                                      option={options}
                                    />
                                      
                                  } else {
                                        
                                        // その他vectorの汎用処理
                                        return <VectorGrid
                                          id={options.id}
                                          url={options.url}
                                          layerName={options.layerName}
                                          color={options.color}
                                          opacity={options.opacity}
                                          borderColor={options.borderColor}
                                        />
                                    }
                                } else if (options.type == "marker") {

                                    if (state[options.id].checked && state[options.id].data.spots) {
                                        return state[options.id].data.spots.map((d, index) =>

                                          renderMarker(options, d, index, state)

                                        )
                                    }
                                    
                                } else if (options.type == "geojson") {

                                    if (state[options.id].checked && state[options.fetchedServerKey].data.features) {
                                        return state[options.fetchedServerKey].data.features.map((feature, index) =>

                                          renderGeoJson(options, feature, index, state)

                                        )
                                    }

                                }
                            })
                        })}
                        
                    </MapContainer>
    
                </div>
            </main>
        </Context.Provider>
    )
}

export default Layout;
